<template>
  <div class="app-main-inner">
    <div class="app-main-inner-row">
      <div class="triggers">
        <el-button type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :side-bar="sideBarDefs"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;"
        @gridReady="onGridReady"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item label="Charge">
            <el-select v-model="editDialog.form.chargeItem" @change="changeChargeItemHandler">
              <el-option
                v-for="item in chargeList"
                :key="item.chargeItemCode"
                :label="item.chargeItemCode"
                :value="item.chargeItemCode"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Unit Rate">
            <el-input-number v-model="editDialog.form.unitRate" :min="0" :precision="2" controls-position="right" />
          </el-form-item>
          <el-form-item label="Measure">
            <el-select v-model="editDialog.form.measure" @change="onMeasureChange">
              <el-option
                v-for="item in measures"
                :key="item.code"
                :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Min Amount">
            <el-input-number v-model="editDialog.form.minAmount" :min="0" :precision="2" controls-position="right" />
          </el-form-item>
          <el-form-item label="Remark">
            <el-input v-model="editDialog.form.remark" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { AutoIncrementNum } from '@/utils/commonUtil'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getMAWBInfoOtherChargeList } from '@/api/partner/mawbInfoOtherCharge'
import { getOtherChargeItemList } from '@/api/basicData/otherChargeItem'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'MAWBInfoOtherCharge',
  data() {
    return {
      chargeList: [],
      measures: AirExportConstants.OTHER_CHARGE_ITEM_MEASURE,
      mawbInfo: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      columnDefs: [
        {
          headerName: 'Charge',
          field: 'chargeItem',
          width: 200
        }, {
          headerName: 'Unit Rate',
          field: 'unitRate',
          width: 200,
          cellRenderer: params => {
            return Number(params.value ? params.value : 0).toFixed(2)
          }
        }, {
          headerName: 'Measure',
          field: 'measure',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.columnLabelFunc(this.measures, params.value)
          }
        }, {
          headerName: 'Min Amount',
          field: 'minAmount',
          width: 200,
          cellRenderer: params => {
            return Number(params.value ? params.value : 0).toFixed(2)
          }
        }, {
          headerName: 'Remark',
          field: 'remark',
          width: 200
        }
      ],
      rowData: [],
      deletedMAWBInfoOtherChargeKeys: [],
      gridApi: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          chargeName: '',
          measure: '',
          unitRate: '',
          minAmount: '',
          remark: '',
          mawbInfoUuid: ''
        }
      },
      autoIncrementNum: new AutoIncrementNum()
    }
  },
  created() {
    // this.measures.push({ label: this.$t('baseInfo.basicData.otherChargeItem.chargeWeight'), value: 'chargeWeight' })
    // this.measures.push({ label: this.$t('baseInfo.basicData.otherChargeItem.job'), value: 'job' })
    // this.measures.push({ label: this.$t('baseInfo.basicData.otherChargeItem.wt'), value: 'wt' })
    getOtherChargeItemList().then(resp => {
      this.chargeList = resp.data.list
    })
  },
  methods: {
    async onShow(mawbInfo) {
      this.mawbInfo = mawbInfo
      if (!mawbInfo.mawbInfoOtherCharges) {
        if (this.mawbInfo.uuid) {
          await this.toQuery()
        } else {
          this.rowData = []
        }
      } else {
        this.rowData = mawbInfo.mawbInfoOtherCharges
      }
      if (!this.mawbInfo.deletedMAWBInfoOtherChargeKeys) {
        this.mawbInfo.deletedMAWBInfoOtherChargeKeys = []
      }
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.onGridDateRendered()
    },
    toQuery() {
      const loading = getLoading4Cxt(this)
      getMAWBInfoOtherChargeList({ mawbInfoUuid: this.mawbInfo.uuid }).then(res => {
        res.data.forEach(p => {
          p.seq = this.autoIncrementNum.getNextNum()
        })
        this.rowData = res.data
        this.mawbInfo.mawbInfoOtherCharges = this.rowData
        this.onGridDateRendered()
      }).finally(() => {
        loading.close()
      })
    },
    onGridDateRendered() {
      const columnApi = this.gridApi.columnController.columnApi
      const columnIds = []
      this.gridApi.columnController.gridColumns.forEach(p => {
        columnIds.push(p.colId)
      })
      setTimeout(() => {
        columnApi.autoSizeColumns(columnIds)
      })
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          chargeName: '',
          measure: '',
          unitRate: '',
          minAmount: '',
          remark: '',
          mawbInfoUuid: this.mawbInfo.uuid,
          seq: this.autoIncrementNum.getNextNum()
        }
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        let node = null
        const cell = this.gridApi.getFocusedCell()
        if (cell) {
          const nodes = this.gridApi.rowModel.rowsToDisplay
          node = nodes[cell.rowIndex] || null
        }
        if (!node) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...node.data }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    save() {
      const form = this.editDialog.form
      const oldRow = this.rowData.find(p => p.seq === form.seq)
      if (oldRow) {
        Object.assign(oldRow, form)
        this.gridApi.refreshCells({ force: true })
      } else {
        this.rowData.push(form)
      }
      this.mawbInfo.mawbInfoOtherCharges = this.rowData
      this.editDialog.visible = false
    },
    remove() {
      let node = null
      const cell = this.gridApi.getFocusedCell()
      if (cell) {
        const nodes = this.gridApi.rowModel.rowsToDisplay
        node = nodes[cell.rowIndex] || null
      }
      if (!node) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const index = this.rowData.findIndex(p => p.seq === node.data.deq)
        this.rowData.splice(index, 1)
        if (node.data.uuid) {
          this.mawbInfo.deletedMAWBInfoOtherChargeKeys.push(node.data.uuid)
        }
        this.mawbInfo.mawbInfoOtherCharges = this.rowData
      }).catch(() => { })
    },
    changeChargeItemHandler(val) {
      const obj = this.chargeList.find(params => params.chargeItemCode === val)
      // 默认应收单价
      this.editDialog.form.unitRate = obj.defaultApPrice
      // 费用计费方式
      this.editDialog.form.measure = obj.measure
    },
    onMeasureChange(val) {
      if (val === AirExportConstants.GENERAL_CHARGE.code) {
        this.editDialog.form.unitRate = 1
      }
    }
  }
}
</script>

<style>
</style>
